/**
 * TASK-681 / TASK-736 — Admin v2 design tokens.
 *
 * Light + dark left-rail variants. User toggle persists in localStorage
 * (`admin_v2_rail_mode`). Content surface tokens stay shared (light content).
 */

const shared = {
  bg: "#f4f5f7",
  surface: "#ffffff",
  surfaceElevated: "#ffffff",
  border: "#e5e7eb",
  borderStrong: "#d1d5db",
  text: "#111827",
  textMuted: "#6b7280",
  textInverse: "#ffffff",
  primary: "#ea4335",
  primaryHover: "#d93025",
  primarySoft: "#fdecea",
  accent: "#4285f4",
  accentHover: "#1b449e",
  accentSoft: "#e8f0fe",
  danger: "#d93025",
  dangerSoft: "#fdecea",
  warning: "#f9ab00",
  warningSoft: "#fef7e0",
  success: "#188038",
  successSoft: "#e6f4ea",
};

const layout = {
  radius: { sm: 8, md: 12, lg: 16 },
  shadow: {
    card: "0 1px 2px rgba(16,24,40,0.06), 0 1px 3px rgba(16,24,40,0.08)",
    modal: "0 16px 48px rgba(16,24,40,0.18)",
  },
  font: {
    family: 'Poppins, Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  navWidth: 260,
};

export const ADMIN_V2_RAIL_STORAGE_KEY = "admin_v2_rail_mode";

/** Dark left rail — modern black menu. */
export const adminV2ThemeDark = {
  ...layout,
  railMode: "dark",
  colors: {
    ...shared,
    navBg: "#0f1115",
    navText: "#e5e7eb",
    navMuted: "#9ca3af",
    navActive: "#1a1d24",
    navHover: "#161920",
    navActiveBar: "#ea4335",
    navActiveText: "#ffffff",
    navBorder: "rgba(255,255,255,0.08)",
    navSoonBg: "rgba(255,255,255,0.08)",
    navButtonBorder: "rgba(255,255,255,0.2)",
    navLogoPlate: "#ffffff",
  },
};

/** Light left rail — white + dark lettering. */
export const adminV2ThemeLight = {
  ...layout,
  railMode: "light",
  colors: {
    ...shared,
    navBg: "#ffffff",
    navText: "#111827",
    navMuted: "#6b7280",
    navActive: "#fdecea",
    navHover: "#f9fafb",
    navActiveBar: "#ea4335",
    navActiveText: "#111827",
    navBorder: "#e5e7eb",
    navSoonBg: "#f3f4f6",
    navButtonBorder: "#d1d5db",
    navLogoPlate: "transparent",
  },
};

export function getAdminV2Theme(railMode) {
  return railMode === "dark" ? adminV2ThemeDark : adminV2ThemeLight;
}

export function readStoredRailMode() {
  try {
    const v = localStorage.getItem(ADMIN_V2_RAIL_STORAGE_KEY);
    if (v === "dark" || v === "light") return v;
  } catch {
    /* ignore */
  }
  return "light";
}

export function writeStoredRailMode(mode) {
  try {
    localStorage.setItem(ADMIN_V2_RAIL_STORAGE_KEY, mode === "dark" ? "dark" : "light");
  } catch {
    /* ignore */
  }
}

/** Default export for page imports (content tokens; rail overridden in layout). */
export const adminV2Theme = adminV2ThemeLight;
